import is from '@sindresorhus/is';

import type { FormEventHandler, KeyboardEventHandler } from 'react';

type Nullable<T> = {
    readonly [P in keyof T]: T[P] | null;
};

export const nullifyEmptyStringValues = <T extends Record<number | string, unknown>>(record: T): Nullable<T> => {
    const nullifiedEmptyStringEntries = Object.entries(record).map(([key, value]) => {
        const newValue = is.emptyString(value) ? null : value;

        return [key, newValue];
    });

    return Object.fromEntries(nullifiedEmptyStringEntries);
};

export const onEnterKeyDownPreventDefault: KeyboardEventHandler = (keyEvent) => {
    if (keyEvent.key === 'Enter' && (keyEvent.target as unknown as HTMLInputElement)?.type !== 'textarea') {
        keyEvent.preventDefault();
        keyEvent.stopPropagation();
    }
};

export const onSubmitPreventDefault: FormEventHandler = (formEvent) => {
    formEvent.preventDefault();
    formEvent.stopPropagation();
};
